import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useAuth } from "@/hooks/useAuth";
import { useImpersonation } from "@/hooks/useImpersonation";
import { LogOut, User, Shield, UserX } from "lucide-react";
import { toast } from "sonner";
import { NotificationCenter } from "@/components/NotificationCenter";

export function UserHeader() {
  const { user, signOut, isImpersonating, impersonatedUser } = useAuth();
  const { stopImpersonation } = useImpersonation();

  const handleSignOut = async () => {
    try {
      await signOut();
      toast.success("Signed out successfully");
    } catch (error) {
      toast.error("Failed to sign out");
    }
  };

  const isUberAdmin = user && ['matt.monjan@infusedu.com', 'matt.monjan@infusesdu.com'].includes(user.email || '');

  if (!user) return null;

  return (
    <div className="border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      {isImpersonating && impersonatedUser && (
        <div className="bg-amber-100 dark:bg-amber-900/30 border-b border-amber-200 dark:border-amber-800">
          <div className="container mx-auto px-4 py-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2 text-sm">
                <UserX className="h-4 w-4 text-amber-700 dark:text-amber-400" />
                <span className="font-medium text-amber-900 dark:text-amber-200">
                  Viewing as: {impersonatedUser.full_name || impersonatedUser.email}
                </span>
              </div>
              <Button
                size="sm"
                variant="outline"
                onClick={stopImpersonation}
                className="h-7 text-xs border-amber-300 hover:bg-amber-200 dark:border-amber-700 dark:hover:bg-amber-900/50"
              >
                <UserX className="h-3 w-3 mr-1" />
                Stop Impersonation
              </Button>
            </div>
          </div>
        </div>
      )}
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2">
              <User className="h-5 w-5 text-muted-foreground" />
              <span className="font-medium">{user.email}</span>
            </div>
            {isUberAdmin && (
              <Badge variant="secondary" className="bg-red-100 text-red-800">
                <Shield className="h-3 w-3 mr-1" />
                Uber Admin
              </Badge>
            )}
          </div>
          
          <div className="flex items-center gap-3">
            <NotificationCenter />
            <Button 
              variant="outline" 
              size="sm" 
              onClick={handleSignOut}
              className="flex items-center gap-2"
            >
              <LogOut className="h-4 w-4" />
              Sign Out
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}